import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { deletePortaluser } from './redux/reduxApi';

const actions = {
  deletePortaluser,
  closeModal,
};

function ModalDeletePortaluser({ data, deletePortaluser, closeModal }) {
  const { auth, history, item, classyears } = data;

  function handleDelete() {
    let newClassyears = [];
    if (classyears?.[0]) {
      for (let i = 0; i < classyears.length; i++) {
        let cy = classyears[i];
        let students = cy.students && JSON.parse(cy.students);
        let newStudents = students.filter((s) => s.nis + '' !== item.nis + '');
        let updateAbsenceStudents = newStudents.map((s, index) => {
          return { ...s, noabsen: index + 1 };
        });
        let newCy = { ...cy, students: JSON.stringify(updateAbsenceStudents) };
        newClassyears = [...newClassyears, newCy];
      }
    }

    deletePortaluser({
      auth,
      history,
      values: item,
      classyears: newClassyears,
    });
    closeModal();
  }

  return (
    <Modal variant='danger' closeModal={closeModal}>
      <p className='ml-2 mt-4'>
        Apakah Anda ingin menghapus user portal{' '}
        <span className='has-text-danger has-text-weight-semibold'>{`${item.name}`}</span>
        ?
      </p>
      <div className='flex justify-end align-center pt-5'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeletePortaluser);
